class App {
  #btn = document.querySelector('.btn');
  #firstName = document.querySelector('.input__name');
  #height = document.querySelector('.input__height');
  #mass = document.querySelector('.input__mass');
  #textInfo = document.querySelector('.container__message');
  bmi;

  constructor() {
    this.#btn.addEventListener('click', e => {
      e.preventDefault();

      if (!this.#firstName.value || !this.#height.value || !this.#mass.value)
        return;
      this.#textInfo.textContent = '';
      this.calcBMI();
      this.message();
      this.clearInputs();
    });
  }

  clearInputs() {
    this.#firstName.value = '';
    this.#height.value = '';
    this.#mass.value = '';
  }

  calcBMI() {
    return (this.bmi = this.#mass.value / (this.#height.value / 100) ** 2);
  }

  text(message, emoji) {
    return `
    <h3 class="text center mb-normal text--dark">Welcome, ${
      this.#firstName.value
    }</h3>
    <p class="text mb-small text--dark">
      Your BMI is ${this.bmi.toFixed(2)}.
    </p>
    <p class="text mb-small text--dark">
      ${message}
    </p>
    <p class="text mb-small text--dark">
      For your health please consider to do sports, sleep well and eat
      healthy food.
    </p>
    <div class="container__emoji">${emoji}</div>
    `;
  }

  message() {
    let html;
    let status;

    const checkBMI = this.bmi;
    if (checkBMI <= 18.4) status = 'low';
    if (checkBMI >= 18.5 && checkBMI <= 24.9) status = 'normal';
    if (checkBMI >= 25 && checkBMI <= 29.4) status = 'high';
    if (checkBMI >= 29.5) status = 'greater';

    switch (status) {
      case 'low':
        html = this.text('This is TOO LOW. Please see a doctor.', '👩🏻‍⚕️');
        break;
      case 'normal':
        html = this.text("It look's ok. Keep it like this.", '👨‍⚕️');
        break;
      case 'high':
        html = this.text('Try to lose some weight.', '🏃🏻‍♂️');
        break;
      case 'greater':
        html = this.text('Your BMI is TOO HIGH', '🐷');
        break;
      default:
        console.log('Something goes wrong');
    }
    this.#textInfo.insertAdjacentHTML('beforeend', html);
  }
}
new App();
